import type {GetUploadParamsOptions} from './types';

import {envManager} from '../../../env';
import {readBlobAs} from './readBlobAs';

export const getUploadParams = async (
  input: File | string,
  {authorId, mimetype, name}: GetUploadParamsOptions = {},
) => {
  const blob = input as File;

  const buffer = await readBlobAs(blob, 'ArrayBuffer');

  let jsmd5;

  if (process.env.NODE_ENV === 'test' || envManager.get('isB2bWidget')) {
    jsmd5 = require('js-md5');
  } else {
    jsmd5 = await import('js-md5' /* webpackChunkName: "md5" */);
    jsmd5 = jsmd5.default;
  }

  const params = {
    author_id: authorId,
    filename: name || blob.name,
    md5: jsmd5(buffer),
    mimetype: mimetype || blob.type,
    size: blob.size,
  };

  return {file: blob, params};
};
